import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import ResourceItem from '../ResourceItem';
import RightContentLayout from '../layout/RightContentLayout';
import BodyContentLayout from '../layout/BodyContentLayout';
import LeftContentLayout from '../layout/LeftContentLayout';
import { SubunitAssessmentTypes } from 'legacy-packages/unit-outline/src/constants';
import { ResourceTypes } from '../../utils/constants';
import Resource from '../Resource';

const IconMap = {
  PPC: 'progress_check',
  PE: 'practice-exam',
  LC: 'learning_checkpoints',
  PT: 'performance_tasks',
};

const IconClassMap = {
  PPC: 'fill-current text-blue-700',
  PE: 'fill-current text-green-400',
  LC: 'fill-current text-blue-700',
  PT: 'fill-current text-blue-700',
};

const ProgressChecks = ({
  getResourceActions,
  getAssignmentUrl,
  resources = [],
  showRightContent = true,
  onResourceClicked = () => {},
  unitDisplayName,
  subunitType = SubunitAssessmentTypes.PPC,
  useClassroomResourceAddress,
  unitNumber,
}) => {
  const styles = cn({ 'desktop:w-full': !showRightContent });
  const title = unitDisplayName || 'Progress Checks';

  return (
    <BodyContentLayout>
      {showRightContent && (
        <RightContentLayout
          showIcon
          title={title}
          icon={IconMap[subunitType]}
        />
      )}

      <LeftContentLayout layoutClassName={styles}>
        {resources.map((resource) => {
          const { displayName, assessmentId, description } = resource;
          const url = getAssignmentUrl(assessmentId, resource);
          const resourcesActions = getResourceActions(resource);

          const resourceContent = (
            <Fragment>
              <div className="text-2xl font-medium">{displayName}</div>
              <div className="text-base mt-1">{description}</div>
            </Fragment>
          );
          const iconClassName = IconClassMap[subunitType];
          if (resource.__typename == ResourceTypes.ASSESSMENT) {
            return (
              <ResourceItem
                key={`progres-check-${assessmentId}`}
                iconName="label"
                iconClassName={iconClassName}
                className="hover:bg-blue-100 active:bg-blue-100"
              >
                <div className="flex flex-col">
                  {(url && (
                    <div
                      onClick={() => onResourceClicked(resource, url)}
                      className="hover:underline hover:text-black text-black cursor-pointer"
                    >
                      {resourceContent}
                    </div>
                  )) ||
                    resourceContent}
                </div>
                <div className="ml-auto">{resourcesActions}</div>
              </ResourceItem>
            );
          } else {
            return (
              <Resource
                item={resource}
                unitNumber={unitNumber}
                useClassroomResourceAddress={useClassroomResourceAddress}
              />
            );
          }
        })}
      </LeftContentLayout>
    </BodyContentLayout>
  );
};

ProgressChecks.displayName = 'ProgressChecks';

ProgressChecks.propTypes = {
  getAssignmentUrl: PropTypes.func.isRequired,
  getResourceActions: PropTypes.func.isRequired,
  resources: PropTypes.array.isRequired,
};

ProgressChecks.defaultProps = {
  getAssignmentUrl: () => {},
  getResourceActions: () => {},
  resources: [],
};

export default ProgressChecks;
